import { createSlice } from '@reduxjs/toolkit';
import {
  UserGetAllProduct,
  UserGetSingleProductDetails,
  UserSearchForProductsByTitle,
} from './user_product_services_syn';

export const userProductSlice = createSlice({
  name: 'user_product',
  initialState: {
    product_loader: false,
    allProductLoader: true,
    productDeleteLoader: false,
    productEditLoader: false,
    proEditLoader: false,
    message: '',
    completeProduct: [],
    productDetails: {},
    productImagesDetails: [],
    productthubnailDetails: {},
    productLimit: 20,
    productSkip: 0,
    editProductId: '',
  },
  reducers: {
    clearState: (state) => {
      state.product_loader = false;
      state.message = '';
      state.completeProduct = [];
      state.allProductLoader = true;
      state.productDeleteLoader = false;
      state.productEditLoader = false;
      state.proEditLoader = false;
      state.productDetails = {};
      state.productImagesDetails = [];
      state.productthubnailDetails = {};
      state.productLimit = 10;
      state.productSkip = 0;
      state.editProductId = '';

      return state;
    },

    updateProductSkip: (state, { payload }) => {
      state.productSkip = payload;
    },

    updateProductLimit: (state, { payload }) => {
      state.productLimit = payload;
    },

    updateProductDetails: (state, action) => {
      state.productDetails = action.payload;
    },

    updateCompleteProduct: (state, action) => {
      state.completeProduct = action.payload;
    },

    updateProductImageDetails: (state, action) => {
      state.productImagesDetails = action.payload;
    },

    updateProductId: (state, { payload }) => {
      state.editProductId = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(UserGetAllProduct.pending, (state) => {
        state.product_loader = true;
      })
      .addCase(UserGetAllProduct.fulfilled, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload?.message;
        state.completeProduct = payload?.data;
      })
      .addCase(UserGetAllProduct.rejected, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(UserGetSingleProductDetails.pending, (state) => {
        state.product_loader = true;
      })
      .addCase(UserGetSingleProductDetails.fulfilled, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload.message;
        state.productDetails = payload.data;
      })
      .addCase(UserGetSingleProductDetails.rejected, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload.message;
      });

    builder
      .addCase(UserSearchForProductsByTitle.pending, (state) => {
        state.product_loader = true;
      })
      .addCase(UserSearchForProductsByTitle.fulfilled, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload.message;
        state.userCompleteProductSearch = payload?.data;
      })
      .addCase(UserSearchForProductsByTitle.rejected, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload.message;
      });
  },
});

export const {
  updateProductDetails,
  updateCompleteProduct,
  updateProductSkip,
  updateProductLimit,
  updateProductImageDetails,
  updateProductId,
} = userProductSlice.actions;
export const productSelector = (state) => state.user_product;

export default userProductSlice.reducer;
